import * as React from 'react';
import * as I18n from 'i18n-js';
import { IUserContext, withUserContext } from '@reverbdotcom/commons/dist/components/user_context_provider';
import { isExperimentEnabled } from '@reverbdotcom/commons/dist/user_context_helpers';
import experiments from '@reverbdotcom/commons/dist/experiments';
import { formatExperimentsForEventAttributes } from '@reverbdotcom/commons/dist/elog/mparticle';
import { useViewTracking } from '@reverbdotcom/commons/dist/use_tracking';
import { MParticleEventName } from '@reverbdotcom/commons/dist/elog/mparticle_types';
import { Paths } from '../../shared/url_helpers';

import CmsListingsCollection, { ADDITIONAL_SORTS } from '@reverbdotcom/commons/dist/cms/components/cms_listings_collection';
import { ListingCard } from '@reverbdotcom/commons/dist/components/listing_card';

const COMPONENT_NAME = 'HomepageBumpedListings';
interface IProps extends IUserContext {
  loading?: boolean;
  topProductSlug?: string;
  categoryUuids?: string[];
}

interface affinityRowProps {
  topProductSlug: string;
  categoryUuids: string[];
}

function AffinityRow(props: affinityRowProps) {
  return (
    <CmsListingsCollection
      componentName={COMPONENT_NAME}
      title={I18n.t('discovery.bumpsView.promotedListings')}
      ctaTargetHref={Paths.marketplace.expand({ product_type: props.topProductSlug })}
      sort={ADDITIONAL_SORTS.BUMP_BOOST}
      categoryUuids={props.categoryUuids}
      ssr={false}
      maxCount={12}
      largeTiles
    />
  );
}

function DefaultRow() {
  return (
    <CmsListingsCollection
      componentName={COMPONENT_NAME}
      title={I18n.t('discovery.bumpsView.promotedListings')}
      sort={ADDITIONAL_SORTS.BUMP_BOOST}
      ssr={false}
      maxCount={12}
      largeTiles
    />
  );
}

export function HomepageBumpedListings(props: IProps) {
  const shouldFilterByCategory = isExperimentEnabled(props.user, experiments.LOGGED_IN_HOMEPAGE_PERSONALIZED_BUMP_ROW) && !!props.categoryUuids;

  const unqualifiedView = !props.user.loggedOut;

  const mParticleViewData = {
    componentName: COMPONENT_NAME,
    eventName: MParticleEventName.ComponentView,
    experiments: formatExperimentsForEventAttributes(
      props.user,
      [experiments.LOGGED_IN_HOMEPAGE_PERSONALIZED_BUMP_ROW],
    ),
    hasCategoryAffinities: !!props.categoryUuids,
  };

  useViewTracking(mParticleViewData, unqualifiedView);

  return (
    <>
      {shouldFilterByCategory && props.loading && <ListingCard />}
      {shouldFilterByCategory && !props.loading ?
        <AffinityRow
          topProductSlug={props.topProductSlug}
          categoryUuids={props.categoryUuids}
        /> :
        <DefaultRow />
      }
    </>
  );
}

export default withUserContext(HomepageBumpedListings);



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/homepage/homepage_bumped_listings.tsx